import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export class AuthenticationError extends Error {}
export class UserInfoError extends Error {
  constructor(userinfo, message) {
    super(message);
    this.userinfo = userinfo;
  }
}


const styles = theme => ({
  error: {
    margin: '20px',
    color: theme.palette.error.dark,
  },
});

function ErrorMessage(props) {
  const { classes, error: { userinfo } } = props;

  const infoMessage = userinfo || 'An error has occured';

  return (
    <Typography variant="display2" className={classes.error}>
      {infoMessage}
    </Typography>
  );
}
ErrorMessage.propTypes = {
  error: PropTypes.shape(),
  classes: PropTypes.shape().isRequired,
};

ErrorMessage.defaultProps = {
  error: null,
};

export default withStyles(styles)(ErrorMessage);



// WEBPACK FOOTER //
// ./src/layout/ErrorMessage.jsx